import React from "react";

const PermissionDenied = (): JSX.Element => {
    return (
        <>
            <div>
                <h1>Permission Denied</h1>
            </div>
        </>
    );
};

export default PermissionDenied;
